import { ESlideTo } from './ESlideTo';
import { IBlockedSlidesEvent } from './IBlockedSlidesEvent';
import { ISlidebox } from './ISlidebox';
import { ISlideboxData } from './ISlideboxData';
import { ISlideboxEvent } from './ISlideboxEvent';
import { ISlideboxState } from './ISlideboxState';

export { ESlideTo, IBlockedSlidesEvent, ISlidebox, ISlideboxData, ISlideboxEvent, ISlideboxState };
